/**
 * Shared application constants.
 *
 * Import from this file rather than using magic strings inline so that
 * typos are caught at build time and changes only need to happen in one place.
 */

// ---------------------------------------------------------------------------
// Change function operators
// These values are stored in the database and sent to/from the backend.
// Do NOT change them without a corresponding backend migration.
// ---------------------------------------------------------------------------
export const OPERATORS = {
  ABSOLUTE: 'absoluteValue',
  PERCENTAGE: 'percentage',
  REFERENCE: 'referenceAccount',
};

// ---------------------------------------------------------------------------
// Master Stat GL key prefix
// All virtual Master Stat accounts use this prefix so they can be identified
// without a database lookup.
// ---------------------------------------------------------------------------
export const MASTER_STAT_PREFIX = 'MASTER-';

// ---------------------------------------------------------------------------
// API / network
// ---------------------------------------------------------------------------
/** Maximum number of GL keys sent in a single bulk-fetch request. */
export const BATCH_SIZE = 20;

/** Default API request timeout in milliseconds. */
export const API_TIMEOUT_MS = 30_000;

/** Auto-hide duration (ms) for transient error Snackbars. */
export const SNACKBAR_ERROR_DURATION_MS = 6_000;
